//* Espejo de `api-rendafin/src/modules/quotations/constants/asset-type.ts` (plan v4.3 §7). La fuente es la API: si
//* cambia allá, se cambia aquí.

export const ASSET_TYPE_OPTIONS = [
  { value: 'light_vehicle', label: 'Automóvil o camioneta ligera' },
  { value: 'heavy_vehicle', label: 'Camión o tractocamión' },
  { value: 'machinery', label: 'Maquinaria y equipo' },
  { value: 'technology', label: 'Tecnología y cómputo' },
  { value: 'real_estate', label: 'Inmueble' },
  { value: 'other', label: 'Otro' },
]

export const assetTypeLabel = (value: string | null | undefined): string => ASSET_TYPE_OPTIONS.find((option) => option.value === value)?.label ?? 'Sin tipo'
